import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accumulatedChartValue',
})
export class AccumulatedChartValuePipe implements PipeTransform {
  transform(array: any[], path: string): number {
    if (!Array.isArray(array)) {
      return array;
    }
    return _.reduce(array, (acc, item) => acc + _.get(item, path, 0), 0);
  }
}
